<script>
import tag from '@/js/util/props/tag'

export default {
  props: { ...tag },

  data() {
    return {
      width: window.innerWidth,
    }
  },

  mounted() {
    window.addEventListener('resize', this.setWidth)
    this.setWidth()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setWidth)
  },

  methods: {
    setWidth() {
      this.width = window.innerWidth
      this.$emit('resize', this.width)
    },
  },

  render(createElement) {
    return createElement(this.tag, this.$scopedSlots.default({ width: this.width }))
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/BaseWindowWidth.vue